import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Checkbox from '@material-ui/core/Checkbox';
import EditOutlined from '@material-ui/icons/EditOutlined';
import RoleService from '../../../services/RoleService/RoleService';
import Modules from './Modules';

/**
 * @Description This function lets you return Role component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Role({ role, selectedRoles, setSelectedRoles, showAlert, fetchRoles, setDialog }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [toggle, setToggle] = useState(role.status === 1);
    const label = 'CONTENT.ROLE.';
    const roleModules = role.modules?.split(',');

    const handleChange = (e) => {
        const index = selectedRoles.indexOf(role.id);
        let copyData = [...selectedRoles];
        if (e.target.checked) {
            if (index < 0) {
                copyData.push(role.id);
                setSelectedRoles(copyData);
            }
        } else {
            if (index > -1) {
                copyData.splice(index, 1);
                setSelectedRoles(copyData);
            }
        }
    }

    const handleToggleChange = async (e) => {
        let checked = e.target.checked;
        const updatingFields = [{ field_name: 'status', field_value: checked }];
        const res = await RoleService.putRole({ updatingFields }, role.id);
        if (!res?.status) { showAlert(res.message); }
        if (checked) { setOpen(true); }
        else if (open) { setOpen(false); }
        setToggle(checked);
    }

    return (
        <React.Fragment>
            <TableRow><TableCell style={{ padding: 12 }} /></TableRow>
            <TableRow className="role-row">
                <TableCell className="role-cell">
                    <div><Checkbox style={{ color: 'white' }} size="small" checked={selectedRoles && selectedRoles.indexOf(role.id) !== -1 ? true : false} onChange={handleChange} />
                        <div><div className="role-info">{t(label + 'ROLE-NAME')}</div><div>{role.role_name}</div></div></div>
                </TableCell>
                <TableCell><div className="role-info">{t(label + 'ROLE-DESC')}</div><div className="role-desc">{role.role_description}</div></TableCell>
                <TableCell>
                    <label className="switch">
                        <input type="checkbox" onChange={handleToggleChange} checked={toggle} />
                        <span className="slider round red" />
                    </label>
                </TableCell>
                <TableCell><div className="role-info">{t(label + 'ASSIGNED')}
                    <div className="role-assigned">
                        {roleModules?.slice(0, 2).map((item, itemI) => {
                            return <span key={itemI}>{t('CONTENT.MODULE.' + item)}</span>;
                        })}
                        {roleModules?.length - 2 > 0 && <span>+{roleModules.length - 2}</span>}
                    </div>
                </div>
                </TableCell>
                <TableCell>
                    <IconButton size="small" onClick={() => { setDialog({ type: 'update', role }); }}>
                        <EditOutlined />
                    </IconButton>
                </TableCell>
                <TableCell>
                    <IconButton size="small" onClick={() => { setOpen(!open); }} disabled={!toggle}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow className="role-row">
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Modules role={role} showAlert={showAlert} setOpen={setOpen} fetchRoles={fetchRoles} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
export default Role;
